'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIList from 'UIComponents/list/UIList';
import UITag from 'UIComponents/tag/UITag';
import PureComponent from 'customer-data-ui-utilities/component/PureComponent';
import partial from 'transmute/partial';
import memoize from 'transmute/memoize';
import PropertyInputDomain from 'customer-data-properties/input/PropertyInputDomain';
const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  isPrimaryDomain: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  promoteToPrimary: PropTypes.func,
  'data-selenium-test': PropTypes.string
};
export default class PropertyInputMultipleDomainInput extends PureComponent {
  constructor(props) {
    super(props); // In new code, please use ES6 spread args rather than partials
    // for easier debugging and readability:
    // (...args) => myFunction('partiallyAppliedParam', ...args)

    this.partial = memoize(partial);
    this.state = {
      isInputFocused: false,
      initialValue: props.value,
      duplicateValue: false
    };
  }

  renderBadge() {
    return /*#__PURE__*/_jsx(UITag, {
      className: "m-left-5",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.PropertyInputMultipleDomain.primaryDomainTag"
      })
    });
  }

  renderDropdownContent() {
    const {
      value,
      readOnly,
      disabled,
      onDelete,
      promoteToPrimary
    } = this.props;

    if (readOnly || disabled) {
      return null;
    }

    return /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "transparent",
      buttonText: "Actions",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "transparent",
          size: "extra-small",
          onClick: this.partial(promoteToPrimary, value),
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "customerDataProperties.PropertyInputMultipleDomain.makePrimary"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "transparent",
          size: "extra-small",
          onClick: this.partial(onDelete, value),
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "customerDataProperties.PropertyInputMultipleDomain.delete"
          })
        })]
      })
    });
  }

  renderDropdown() {
    const {
      isInputFocused
    } = this.state;

    if (isInputFocused) {
      return null;
    }

    return this.renderDropdownContent();
  }

  render() {
    const _this$props = this.props,
          {
      readOnly,
      isPrimaryDomain
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, ["readOnly", "isPrimaryDomain", "onDelete", "promoteToPrimary"]);

    const classes = 'p-left-0' + (isPrimaryDomain ? " p-top-2" : "");

    const control = /*#__PURE__*/_jsx(PropertyInputDomain, Object.assign({
      className: "p-x-2",
      readOnly: readOnly
    }, props));

    return /*#__PURE__*/_jsxs(UIGrid, {
      children: [/*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: 8
        },
        children: readOnly ? /*#__PURE__*/_jsx("div", {
          className: "m-top-3 m-bottom-1",
          children: control
        }) : control
      }), /*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: 4
        },
        className: classes,
        children: isPrimaryDomain ? this.renderBadge() : this.renderDropdown()
      })]
    });
  }

}
PropertyInputMultipleDomainInput.propTypes = propTypes;